// src/helpers/rutaHoms.js
import axios from "axios";

const RAW_BASE_URL =
  process.env.REACT_APP_API_BASE || "https://backretiro360.us-3.evennode.com";
const BASE_URL = String(RAW_BASE_URL).replace(/\/+$/, "");

const API = axios.create({ baseURL: BASE_URL });

const p = (s) => String(s || "").replace(/^\/+/, "");

const auth = () => {
  const token = localStorage.getItem("token") || "";
  return token ? { headers: { token } } : {};
};

const debugUrl = (url, params) => console.log("👉 URL:", API.getUri({ url, params }));

export const getHoms = async (params = {}) => {
  const url = p("homs"); // 👈 según tu index, el path es /homs
  debugUrl(url, params);
  const { data } = await API.get(url, { ...auth(), params });
  return Array.isArray(data?.homs) ? data.homs : Array.isArray(data) ? data : [];
};

export const getHomById = async (id) => {
  const url = p(`homs/${id}`);
  debugUrl(url);
  const { data } = await API.get(url, auth());
  return data;
};